import { useQuery } from '@tanstack/react-query';
import { storeQueryOptions, storesQueryOptions } from '../query/query-options';
import { storeLayout } from '../route-apis';

// The current store, from the most authoritative source that has it.
//
// GET /stores/:store-id is the real record and the one that carries `stats`,
// so it wins. storeLayout's loader fetches it for every store route, which is
// why a single hook is enough — there is no route under /stores/$storeId where
// a caller has to know whether the record is loaded.
//
// Two fallbacks remain, and neither is vestigial:
//
//   - The stores list, for the one case the record cannot cover: ReadStore 402s
//     a disabled store more than an hour old, so storeLayout's loader skips it
//     and a lapsed store's `enabled`/`permissions` can only come from the list.
//   - The route context, for the first render of a navigation whose list fetch
//     has not resolved — the same window useStore has always covered.
//
// enabled:false on both — this is a read-only subscriber and never triggers a
// fetch. Unlike skipToken (a truthy Symbol), an undefined queryFn lets
// TanStack's fallback observer scan find the real queryFn when the loader's
// fetch runs.
export function useStore() {
  const { storeId } = storeLayout.useParams();
  const { store: contextStore } = storeLayout.useRouteContext();
  const { data: record } = useQuery({ ...storeQueryOptions(storeId), enabled: false });
  const { data: stores } = useQuery({ ...storesQueryOptions(), enabled: false });

  return record ?? stores?.find((s) => s.id === storeId) ?? contextStore;
}
